import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { PlanningSessionStatus } from 'src/types/planning';
import { PlanningQuestion } from 'src/types/planning';

const rootSelector = (state: RootState) => state.planning;

export interface PlanningState {
    sessionId: string | null;
    status: PlanningSessionStatus | null;
    questions: PlanningQuestion[] | null;
    plan: string | null;
    turnCount: number;
    questId: string | null;
    clarityScore: number | null;
    isLoading: boolean;
    isOffloading: boolean;
    error: string | null;
}

export const PlanningSelectors = (): PlanningState => {
    const sessionId = useSelector((s: RootState) => rootSelector(s)?.sessionId);
    const status = useSelector((s: RootState) => rootSelector(s)?.status);
    const questions = useSelector((s: RootState) => rootSelector(s)?.questions);
    const plan = useSelector((s: RootState) => rootSelector(s)?.plan);
    const turnCount = useSelector((s: RootState) => rootSelector(s)?.turnCount);
    const questId = useSelector((s: RootState) => rootSelector(s)?.questId);
    const clarityScore = useSelector(
        (s: RootState) => rootSelector(s)?.clarityScore
    );
    const isLoading = useSelector((s: RootState) => rootSelector(s)?.isLoading);
    const isOffloading = useSelector(
        (s: RootState) => rootSelector(s)?.isOffloading
    );
    const error = useSelector((s: RootState) => rootSelector(s)?.error);

    return {
        sessionId,
        status,
        questions,
        plan,
        turnCount,
        questId,
        clarityScore,
        isLoading,
        isOffloading,
        error
    };
};
